import { ComparableField } from './types';

export const CHART_COLORS = [
  '#009DE0', '#002A5C', '#2E7D32', '#E30613', '#FFB800',
  '#7B1FA2', '#00838F', '#E65100', '#1565C0', '#4E342E',
  '#AD1457', '#00695C', '#6A1B9A', '#EF6C00', '#283593',
];

export const PLOT_OPTIONS = {
  grouping: true,
  shadow: false,
  borderWidth: 0,
  borderRadius: 4,
} as const;

export const CELL_TYPE_FIELDS: ComparableField[] = [
  { name: 'calendar_life', label: 'Calendar life (years)', range: { from: 'calendar_life_from', to: 'calendar_life_to' } },
  { name: 'cycle_life', label: 'Cycle life', range: { from: 'cycle_life_from', to: 'cycle_life_to' } },
  { name: 'gravimetric_ed', label: 'Gravimetric ED (Wh/kg)', range: { from: 'gravimetric_ed_from', to: 'gravimetric_ed_to' } },
  { name: 'gravimetric_p', label: 'Gravimetric P (W/kg)', range: { from: 'gravimetric_p_from', to: 'gravimetric_p_to' } },
  { name: 'round_trip_eff_dc', label: 'Round trip eff DC (%)', range: { from: 'round_trip_eff_dc_from', to: 'round_trip_eff_dc_to' } },
  { name: 'self_discharge', label: 'Self discharge (%)', range: { from: 'self_discharge_from', to: 'self_discharge_to' } },
  { name: 'theoretical_cell_voltage', label: 'Theoretical cell voltage (V)' },
  { name: 'volumetric_ed', label: 'Volumetric ED (Wh/L)', range: { from: 'volumetric_ed_from', to: 'volumetric_ed_to' } },
];

export const CELL_PRODUCT_FIELDS: ComparableField[] = [
  { name: 'ac_capex', label: 'AC CAPEX' },
  { name: 'bill_of_material', label: 'Bill of material' },
  { name: 'calendar_life', label: 'Calendar life (years)', range: { from: 'calendar_life_from', to: 'calendar_life_to' } },
  { name: 'cycle_life', label: 'Cycle life', range: { from: 'cycle_life_from', to: 'cycle_life_to' } },
  { name: 'dc_capex_i', label: 'DC CAPEX (initial)' },
  { name: 'dc_capex_t', label: 'DC CAPEX (target)' },
  { name: 'gravimetric_energy_density', label: 'Gravimetric Energy Density (Wh/kg)' },
  { name: 'gravimetric_power_density', label: 'Gravimetric Power Density (W/kg)' },
  { name: 'lcos', label: 'LCOS' },
  { name: 'round_trip_eff_dc', label: 'Round trip eff DC (%)', range: { from: 'round_trip_eff_dc_from', to: 'round_trip_eff_dc_to' } },
  { name: 'self_discharge', label: 'Self discharge (%)', range: { from: 'self_discharge_from', to: 'self_discharge_to' } },
  { name: 'shelf_life', label: 'Shelf life (years)', range: { from: 'shelf_life_from', to: 'shelf_life_to' } },
  { name: 'nominal_voltage', label: 'Theoretical cell voltage (V)' },
  { name: 'volumetric_energy_density', label: 'Volumetric Energy Density (Wh/L)' },
];
